import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ReactiveFormsModule } from '@angular/forms';
import { CKEditorModule } from 'ngx-ckeditor';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';


import { HkbkfacilitiesHeadingRoutingModule } from './hkbkfacilities-heading-routing.module';
import { HkbkfacilitiesHeadingListComponent } from './hkbkfacilities-heading-list/hkbkfacilities-heading-list.component';
import { HkbkfacilitiesHeadingCreateComponent } from './hkbkfacilities-heading-create/hkbkfacilities-heading-create.component';

@NgModule({
  declarations: [HkbkfacilitiesHeadingListComponent, HkbkfacilitiesHeadingCreateComponent],
  imports: [
    CommonModule,
    HkbkfacilitiesHeadingRoutingModule,
    NgbModule,
    ReactiveFormsModule,
    CKEditorModule,
    NgxDatatableModule
  ]
})
export class HkbkfacilitiesHeadingModule { }
